import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import ReactSelect from "react-select";

import { CoverageAreaCreateLogic } from "./CoverageAreaCreate.logic";
import Button from "@components/atom/Button";

const CoverageAreaCreate = (props) => {
  const {
    dataCoverageArea,
    onAdd,
    onRemove,
    onChange,
    onSubmit,
    onBack,
    cityOptions,
    isLoading,
    onChangeText,
  } = CoverageAreaCreateLogic(props);

  return (
    <div>
      <div className=' flex w-1/2'>
        <p
          className='font-bold text-xl py-10 pl-3 cursor-pointer'
          onClick={onBack}>
          <FontAwesomeIcon icon={faArrowLeft} className='mr-2 font-bold' />
          Buat Tujuan Pengiriman
        </p>
      </div>
      <table>
        <thead>
          <tr>
            <th className='pl-3 w-1/4'>Kota</th>
            <th className='pl-3 w-1/4'>Kecamatan</th>
            <th className='pl-3 w-1/4'>Minimum Pembelian</th>
            <th className='pl-3 w-1/4'>Ongkos Kirim</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {dataCoverageArea.map((item, index) => {
            return (
              <tr key={index}>
                <td className='p-3 w-1/4'>
                  <ReactSelect
                    isClearable
                    options={cityOptions}
                    onChange={(e) => onChange(e, index, "city")}
                    placeholder={"Cari nama kota"}
                    noOptionsMessage={() => "Tidak ada data"}
                    value={item.city}
                  />
                </td>
                <td className='p-3 w-1/4'>
                  <ReactSelect
                    isClearable
                    options={item.districtOptions}
                    onChange={(e) => onChange(e, index, "district")}
                    placeholder={"Cari nama kecamatan"}
                    noOptionsMessage={() => "Tidak ada data"}
                    value={item.district}
                  />
                </td>
                <td className='p-3 w-1/4'>
                  <input
                    type='text'
                    onChange={(e) => onChangeText(e, index, "minPurchase")}
                    className='form-control'
                    style={{ minHeight: 38 }}
                  />
                </td>
                <td className='p-3 w-1/4'>
                  <input
                    type='text'
                    onChange={(e) => onChangeText(e, index, "shippingFee")}
                    className='form-control'
                    style={{ minHeight: 38 }}
                  />
                </td>
                <td className='p-3'>
                  <p className='cursor-pointer' onClick={() => onRemove(index)}>
                    X
                  </p>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className='p-3'>
        <div className='p-2 border-dashed border-2 border-green-700 cursor-pointer'>
          <p className='text-green-700 text-center' onClick={onAdd}>
            Tambah +
          </p>
        </div>
        <div className='d-flex align-items-center justify-content-center mt-4'>
          <Button
            textButton={isLoading ? "Loading..." : "Submit"}
            onClick={onSubmit}
          />
        </div>
      </div>
    </div>
  );
};

export default CoverageAreaCreate;
